import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { Toaster } from "@/components/ui/sonner";
import { registerServiceWorker } from "./notifications";

// Register service worker for offline + push notifications
registerServiceWorker();

// Suppress benign ResizeObserver loop error (triggered by Radix UI + D3 layout race)
if (typeof window !== 'undefined') {
  // Suppress at the earliest possible level — before React error overlay catches it
  const resizeObserverMsg = 'ResizeObserver loop';
  window.addEventListener('error', (e) => {
    if (e.message && e.message.includes(resizeObserverMsg)) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return false;
    }
  }, true); // capture phase — fires before React's handler

  // Also override window.onerror to catch it from the React dev overlay
  const origOnError = window.onerror;
  window.onerror = function (msg, source, lineno, colno, error) {
    if (msg && typeof msg === 'string' && msg.includes(resizeObserverMsg)) {
      return true; // swallow the error
    }
    if (origOnError) return origOnError(msg, source, lineno, colno, error);
    return false;
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
    <Toaster />
  </React.StrictMode>,
);
